<template>
  <TagsInputRoot
    v-model="modelValue"
    @update:modelValue="handeTagsInput()"
    class="flex gap-1.5 items-start rounded-md flex-wrap bg-white w-full max-w-full max-h-full"
  >
    <TagsInputItem
      v-for="item in modelValue"
      :key="item"
      :value="item"
      class="flex items-center justify-center gap-1 bg-primary aria-[current=true]:bg-primary rounded-sm px-2 border border-primary shrink-0 font-medium"
    >
      <TagsInputItemText class="text-secondary flex gap-2 items-center">
        <InputDropdownItem
          :type="type"
          :item="item"
          :size="size"
          disabled
          :class="cn(tagItemVariants({ size }))"
        />
      </TagsInputItemText>
      <TagsInputItemDelete
        class="p-0 bg-transparent fg-quinary hover:fg-secondary"
      >
        <Icon name="close" />
      </TagsInputItemDelete>
    </TagsInputItem>
  </TagsInputRoot>
</template>

<script setup>
import { ref, toRaw } from "vue";
import { cn } from "@/Utils/cn";
import { Icon } from "@/SharedComponents/Icon";
import {
  TagsInputItem,
  TagsInputItemDelete,
  TagsInputItemText,
  TagsInputRoot,
} from "radix-vue";
import { sizes, InputDropdownItem, tagItemVariants } from ".";

const props = defineProps({
  placeholder: {
    type: String,
  },
  size: {
    type: String,
    default: "md",
    validator: (value) => sizes.includes(value),
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: "default",
  },
});

const modelValue = ref(props.modelValue);

const handeTagsInput = () => {
  emit("update:modelValue", toRaw(modelValue.value));
};
const emit = defineEmits(["update:modelValue"]);
</script>
